import axios from "./axiosService";
import services from "./base";
import { DateTimeFormat } from "./common";

const noteService = {
  getAllTime: async () => {
    try {
      const response = await axios.get(services.urlTime);
      if (response.data.error) {
        return response.data.error;
      } else {
        return response.data;
      }
    } catch (error) {
      console.log(error);
      return error.message;
    }
  },

  getTimebyExpedienteId: async (id) => {
    const response = await axios.get(services.urlTime + "/" + id, { params: { id } });
    return response.data.map((item) => ({
      ...item,
      created_date: DateTimeFormat(item.created_date),
    }));      
    },


  createTime: async (obj) => {
    try {
      const response = await axios.post(services.urlTime, { obj });
      if (response.data.error) {
        return response.data.error;
      } else {
        return response.status;
      }
      
    } catch (error) {
      console.log(error);
      return error.message;
    }
  },

  deleteTimeById: async (id) => {
    const response = await axios.delete(services.urlTime + "/" + id, { params: { id } });
    return response.data;
  },
};

export default noteService;
